/**
 * @fileoverview Account data source and type definitions.
 */

import { AccountSchema, ACCOUNT_TYPE_VALUES, AUTH_PROVIDER_VALUES, type Account } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createAccountTrackingFields, createCreatedAtField, createDeletedAtField, createIdField, createJsonField, createSelectField, createStringField, createUpdatedAtField, FIELD_TYPE_WIDTHS, FIELD_WIDTHS } from './field-factories';
import { getCache } from './cache-registry';

export type { Account };

const providerOptions = AUTH_PROVIDER_VALUES.map((value) => ({ value, label: value }));
const accountTypeOptions = ACCOUNT_TYPE_VALUES.map((value) => ({ value, label: value }));

export const accountDataSource = createBaseDataSource<Account>({
  endpoint: 'account',
  searchField: 'username',
  schema: AccountSchema,
  fields: [
    createIdField(),
    createSelectField('provider', 'Provider', providerOptions, FIELD_WIDTHS.SMALL),
    createStringField('provider_user_id', 'Provider User ID', FIELD_WIDTHS.MEDIUM),
    createStringField('username', 'Username', FIELD_TYPE_WIDTHS.NAME),
    createStringField('display_name', 'Display Name', FIELD_TYPE_WIDTHS.NAME),
    createStringField('email', 'Email', FIELD_TYPE_WIDTHS.EMAIL),
    createStringField('avatar_url', 'Avatar URL', FIELD_WIDTHS.MEDIUM),
    createSelectField('account_type', 'Account Type', accountTypeOptions, FIELD_WIDTHS.SMALL),
    createJsonField('metadata', 'Metadata', FIELD_WIDTHS.MEDIUM),
    ...createAccountTrackingFields({ includeCreated: false }),
    createCreatedAtField(),
    createUpdatedAtField(),
    createDeletedAtField(),
  ],
});

export const accountCache = getCache('account');
